import { EventEmitter, Injectable, Output } from '@angular/core';
import { Daytran } from 'src/core/daytran.model';
import { Http } from '@angular/http';
import { environment } from '../../environments/environment';
import { CompanyService } from '../company.service';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class DaytranService {
  addDaytran = environment.baseUrl + '/AndroidAPI_server/addDaytranWebClock.php';
  getDayTran = environment.baseUrl + '/AndroidAPI_server/getDaytranWebClock.php';
  getTimeLogs = environment.baseUrl + '/AndroidAPI_server/getTimeLogs.php';
  getSupervisor = environment.baseUrl + '/AndroidAPI_server/getSupervisor.php';
  cancelReq = environment.baseUrl + '/AndroidAPI_server/cancelReqOb.php';
  syapar = environment.baseUrl + '/AndroidAPI_server/getWebclockSyspar.php';
  exportTimeLogs = environment.baseUrl + '/AndroidAPI_server/exportTimeLogs.php';

  constructor(
    public http: Http,
    public companyService: CompanyService
  ) { }

  async sendDaytran(body, image?): Promise<any> {
    body = {
      ...body,
      ...{
        comcde: await this.companyService.getComcde()
      }
    }
    return await this.http.post(this.addDaytran, { body: body, image: image }).toPromise()
      .then(resp => resp.json() as Array<any>);
  }

  async getDaytran(): Promise<any> {
    const body = {
      comcde: await this.companyService.getComcde()
    }
    return await this.http.post(this.getDayTran, body).toPromise()
      .then(resp => resp.json() as Array<any>);
  }

  async getTimelogs(body): Promise<any> {
    body = {
      ...body,
      ...{
        comcde: await this.companyService.getComcde()
      }
    }
    return await this.http.post(this.getTimeLogs, body).toPromise()
      .then(resp => resp.json() as Array<any>);
  }

  async requestCancel(body): Promise<any> {
    body = {
      ...body,
      ...{
        comcde: await this.companyService.getComcde()
      }
    }
    return await this.http.post(this.cancelReq, body).toPromise()
      .then(resp => resp.json() as Array<any>);
  }

  async validateSupervisor(body): Promise<any> {
    body = {
      ...body,
      ...{
        comcde: await this.companyService.getComcde()
      }
    }
    return await this.http.post(this.getSupervisor, body).toPromise()
      .then(resp => resp.json() as Array<any>);
  }

  async photoEnabled(): Promise<any> {
    const body = {
      comcde: await this.companyService.getComcde()
    }
    return await this.http.post(this.syapar, body).toPromise()
      .then(resp => resp.json() as Array<any>);
  }

  async exportTimelogs(body): Promise<any> {
    console.log(body);
    body = {
      ...body,
      ...{
        comcde: await this.companyService.getComcde()
      }
    }
    const xres = await this.http.post(this.exportTimeLogs, body)
      .toPromise()
      .then(resp => resp.json() as Array<any>);

    const filename = 'webclockentries (' + body.datefrom + ' to ' + body.dateto + ') - ' + moment().format('YYYYMMDDHmm') + '.txt';

    const xdatafile = xres['datafile'];
    const blob = new Blob([xdatafile], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, filename);
  }
}
